import { LocationStrategy, PathLocationStrategy, registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import localeFr from "@angular/common/locales/fr";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from "@azure/msal-angular";
import { PublicClientApplication } from "@azure/msal-browser";
import { NgAsModule } from "ng-as";
import { NgLetDirective } from "ng-let";
import { BaseChartDirective } from "ng2-charts";
import { MarkdownModule } from "ngx-markdown";
import { ToastrModule } from "ngx-toastr";
import { AppComponent } from "src/app/app.component";
import { AppRoutingModule } from "src/app/app.routing";
import { msalConfig, msalGuardConfig, msalInterceptorConfig } from "src/app/auth-config";
import { AppCommonModule } from "src/app/common/app-common.module";
import { configServiceInitializer } from "src/app/common/services/config.service";
import { PageTitleService } from "src/app/common/services/page-title.service";
import { GlobalErrorHandler } from "src/app/global-error-handler";
import { AppLayoutModule } from "src/app/layout/app.layout.module";
import { ErrorPageModule } from "src/app/modules/error-page/error-page.module";
import { VersionInterceptor } from "src/app/version.interceptor";

@NgModule({
  imports: [
    AppCommonModule,
    AppLayoutModule,
    AppRoutingModule,
    BaseChartDirective,
    BrowserAnimationsModule,
    BrowserModule,
    ErrorPageModule,
    MarkdownModule.forRoot(),
    MsalModule.forRoot(new PublicClientApplication(msalConfig), msalGuardConfig, msalInterceptorConfig),
    NgAsModule,
    NgLetDirective,
    ToastrModule.forRoot({
      closeButton: true,
      extendedTimeOut: 5_000,
      maxOpened: 5,
      newestOnTop: true,
      preventDuplicates: true,
      progressBar: true,
      resetTimeoutOnDuplicate: true,
      timeOut: 10_000,
      positionClass: "toast-fixed",
    }),
  ],
  declarations: [AppComponent],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    configServiceInitializer,
    Location,
    MsalBroadcastService,
    provideHttpClient(withInterceptorsFromDi()),
    MsalGuard,
    MsalService,
    PageTitleService,
  ],
  exports: [],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {
  constructor(titleService: PageTitleService) {
    titleService.init();
  }
}

registerLocaleData(localeFr, "fr-CH");
